import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simulador-credito',
  templateUrl: './simulador-credito.component.html',
  styleUrls: ['./simulador-credito.component.scss']
})
export class SimuladorCreditoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
